module.exports = __webpack_public_path__ + "static/media/psm1.763b3b40.png";